module.exports = __webpack_public_path__ + "static/media/grin.55f52091.svg";